<div class="relative px-4 dark:bg-contrast-black">
    <div class="journey-inputs relative flex flex-col gap-4">
        <ion-item id="origin" role="button" color="light" lines="none" detail="false" button>
            <ion-icon
                class="vl-app-light:text-grey-zambezy var-app-light:text-grey-zambezy orb-app-light-dark:text-3xl orb-app-light:text-grey-zambezy text-old_silver text-3xl dark:text-contrast-black"
                title="{{ 'ORIGIN' | translate }}"
                attr.aria-label="{{ 'ORIGIN' | translate }}"
                src="{{ assetsPath$ | async }}/img/journey-planner/origin.svg"></ion-icon>
            <ion-label class="text-base leading-6">
                <span class="var-app-light:text-grey-zambezy text-ironside_grey dark:text-contrast-black"
                    >{{ 'LOCAL_LABEL_FROM' | translate }}:&nbsp;
                </span>
                <ng-container [ngSwitch]="(search$ | async)?.origin?.name">
                    <span *ngSwitchCase="'LOCATION_FROM_MAP'">{{ 'LOCATION_FROM_MAP' | translate }}</span>
                    <span *ngSwitchCase="'CURRENT_LOCATION'">{{ 'CURRENT_LOCATION' | translate }}</span>
                    <span *ngSwitchDefault>{{ (search$ | async)?.origin?.name }}</span>
                </ng-container>
                <span
                    *ngIf="
                        env.JOURNEY_PLANNER?.SHOW_MUNICIPALITY_IN_STOP_NAME &&
                        (search$ | async)?.origin?.municipalityName
                    ">
                    ({{ (search$ | async)?.origin?.municipalityName }})
                </span>
            </ion-label>
        </ion-item>

        <ion-button
            class="change-button absolute bottom-0 right-4 top-0 z-10 my-auto h-12 w-12 text-lg"
            [attr.aria-label]="'SWAP_ROUTES' | translate"
            (click)="toggleSwapRoutes()"
            fill="clear">
            <ion-icon
                class="var-app-light-dark:text-4xl var-app-light:text-black orb-app-light-dark:text-4xl text-base text-secondary dark:text-contrast-black"
                title="{{ 'SWAP_ROUTES' | translate }}"
                attr.aria-label="{{ 'SWAP_ROUTES' | translate }}"
                src="{{ assetsPath$ | async }}/img/journey-planner/icon-change.svg"></ion-icon>
        </ion-button>

        <ion-item id="destination" role="button" color="light" lines="none" detail="false" button>
            <ion-icon
                class="text-old_silver vl-app-light:text-grey-zambezy orb-app-light-dark:text-3xl var-app-light:text-grey-zambezy orb-app-light:text-grey-zambezy text-3xl dark:text-contrast-black"
                title="{{ 'DESTINATION' | translate }}"
                attr.aria-label="{{ 'DESTINATION' | translate }}"
                src="{{ assetsPath$ | async }}/img/journey-planner/destination.svg"></ion-icon>
            <ion-label class="text-base leading-6">
                <span class="var-app-light:text-grey-zambezy text-ironside_grey dark:text-contrast-black"
                    >{{ 'LOCAL_LABEL_TO' | translate }}:&nbsp;</span
                >
                <ng-container [ngSwitch]="(search$ | async)?.destination?.name">
                    <span *ngSwitchCase="'LOCATION_FROM_MAP'">{{ 'LOCATION_FROM_MAP' | translate }}</span>
                    <span *ngSwitchCase="'CURRENT_LOCATION'">{{ 'CURRENT_LOCATION' | translate }}</span>
                    <span *ngSwitchDefault>{{ (search$ | async)?.destination?.name }}</span>
                </ng-container>
                <span
                    *ngIf="
                        env.JOURNEY_PLANNER?.SHOW_MUNICIPALITY_IN_STOP_NAME &&
                        (search$ | async)?.destination?.municipalityName
                    ">
                    ({{ (search$ | async)?.destination?.municipalityName }})
                </span>
            </ion-label>
        </ion-item>
    </div>

    <div class="flex-justify-between flex flex-wrap items-stretch">
        <ion-button
            class="schedule var-app-light-dark:text-black orb-app-light-dark:text-xm min-h-12 my-0 h-auto max-w-full whitespace-normal break-words text-xs font-semibold normal-case text-secondary dark:text-contrast-yellow"
            id="open-time-modal"
            [attr.aria-label]="'LEAVE_NOW' | translate"
            (click)="onOpenDatetimeModal()"
            fill="clear">
            <div class="min-h-12 flex items-center">
                <mat-icon
                    class="var-app-light-dark:text-black var-app-dark:text-contrast-yellow mr-1 flex-shrink-0 text-secondary">
                    schedule
                </mat-icon>
                <span class="break-words">
                    {{ isTimeFilterSet ? getTimeLabel() : ('LEAVE_NOW' | translate) }}
                </span>
            </div>
        </ion-button>
        <ion-button
            class="var-app-light-dark:text-black orb-app-light-dark:text-xm my-0 h-auto max-h-full p-0 text-xs font-semibold normal-case text-secondary filter dark:text-contrast-yellow"
            *ngIf="routes"
            [attr.aria-label]="'FILTER' | translate"
            (click)="toggleRoutesFilter()"
            fill="clear">
            <div class="flex h-12 w-full items-center justify-center">
                <div class="flex items-center justify-center rounded-xl px-2.5 py-1.5" [ngClass]="filterButtonClass">
                    <ion-icon
                        class="var-app-light-dark:text-black mr-1 text-secondary dark:filter-yellow"
                        [ngClass]="filterIconClass"
                        src="{{ assetsPath$ | async }}/img/journey-planner/icon-settings.svg"
                        title="{{ 'FILTER' | translate }}"
                        aria-label="{{ 'FILTER' | translate }}"
                        aria-hidden="true">
                    </ion-icon>
                    {{ 'FILTER' | translate }}
                </div>
            </div>
        </ion-button>
    </div>
</div>

<ridango-ui-datetime-select
    [(ngModel)]="filterDepartTime"
    [minDate]="minDateForFilter"
    [maxDate]="maxDateForFilter"
    (ngModelChange)="setSearchDateAndTime()"
    triggerId="open-time-modal"
    showDepartArriveToggle="true">
</ridango-ui-datetime-select>

<ion-accordion-group class="route-filter bg-[#f0f0f0] dark:bg-contrast-black" #accordionGroup>
    <ion-accordion value="second">
        <div *ngIf="!env.JOURNEY_PLANNER?.FILTERS?.SHOW_FILTERS_IN_MODAL" slot="content">
            <rwidget-journey-planner-filter [currentFilter]="filter" (filterChanged)="filterChangedHandler($event)">
            </rwidget-journey-planner-filter>
        </div>
    </ion-accordion>
</ion-accordion-group>

<rwidget-journey-planner-search-modal [modalType]="modalTypeEnum.Origin"></rwidget-journey-planner-search-modal>
<rwidget-journey-planner-search-modal [modalType]="modalTypeEnum.Destination"></rwidget-journey-planner-search-modal>
